import React, { createContext, useCallback, useState } from "react";

export const AttributePairValidationContext = createContext({});

export const AttributePairValidationProvider = ({ children }) => {
    const [attributeValidationDetails, setAttributeValidationDetails] = useState([]);

    const handleRequireBy = useCallback((uuid, pairedUuid, value) => {
        setAttributeValidationDetails([
            {
                uuid,
                pairedUuid,
                value,
            },
        ]);
    }, []);

    return (
        <AttributePairValidationContext.Provider value={{ onRequireBy: handleRequireBy, validationDetails: attributeValidationDetails }}>
            {children}
        </AttributePairValidationContext.Provider>
    );
};
